module.exports = __webpack_public_path__ + "img/1728542402372-WIN_20241010_14_26_46_Pro.jpg.f6b0ae9f.webp";